module.exports = __webpack_public_path__ + "img/gitlab-logo.2906be58.svg";